import { Component, OnInit } from '@angular/core';
import { RequestService } from '../service/request.service';
import { NotifierService } from 'angular-notifier';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'app-po-modal-view',
  templateUrl: './po-modal-view.component.html',
  styleUrls: ['./po-modal-view.component.scss']
})
export class PoModalViewComponent implements OnInit {
  constructor(
    public requestService:RequestService,
    private notifiy:NotifierService,
    private dialog:MatDialog
  ) { }

  ngOnInit(): void {
  }

  

  onSubmit(){
    if(this.requestService.poNum != ''){
      this.requestService.poNumSubmit();
    }else{
      this.notifiy.notify('error','Please Enter Po Number')
    }
  }

  onSkip(){
    this.requestService.onSkipPoNum();
  }

}
